import React,{useEffect} from 'react'
import sliderCloseIcon from '../../assets/images/slider-close-icon.svg';
import { apiCall } from '../../functions/utils';

export default function ReminderContactSlider({selectedContact}) {


  const getContactReminders=async()=>{
    const response = await apiCall(true, "GET", `/api/reminders/${selectedContact.id}`)
    console.log(response)

  }  
  useEffect(()=>{
    getContactReminders()
  },[selectedContact])  
  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="reminderContactCanvas"
    aria-labelledby="reminderContactCanvasLabel">
    <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="reminderContactCanvasLabel d-flex align-items-center">Reminders <span
                className="reminder-name-btn me-1">{selectedContact.full_name}</span></h5>
        <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas"><img
                src={sliderCloseIcon} className="img-fluid"/></button>
    </div>
    <div className="offcanvas-body">
        <div className="mt-4 reminder-tabs d-flex">
            <button>Add New Reminder</button>
            <button>Upcoming Reminder</button>
            <button>History</button>
        </div>
        <select className="form-select slider-inputs" aria-label="Default select example">
            <option value="">Select Reminder Type</option>
            <option value={1}>Scheduled</option>
            <option value={2}>Unscheduled</option>
        </select>

        <div className="form-check mt-4">
            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
            <label className="form-check-label" htmlFor="flexCheckDefault">
                Recurring
            </label>
        </div>

        <select className="form-select slider-inputs" aria-label="Default select example">
            <option value="">Select Reminder</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
        </select>

        <div className="mt-4 d-flex justify-content-center">
            <button style={{width: '282px'}} className="secondary-btn" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#createContactCanvas" aria-controls="createContactCanvas">
                Add Reminder
            </button>
        </div>

        <div className="d-flex justify-content-end mt-4">
            <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
        </div>
    </div>
</div>
  )
}
